import * as types from './mutations_types.js'
// import {app} from '../main'

// 為了設定語系引入 i18n
//import {app} from '../main'
//import i18n from '../main.js'

export const state = {
  loadCount: 0,
  loading: true,
  lang: localStorage.lang || 'tw',
  user: {
    iD: '',
    name: '匿名者',
    type: '',
    status: '4',
    loginTime: new Date(),
    isInit: false
  },
  appId: -1,
  pageId: -1
}

export const actions = {
  toggleLoading ({ commit }, isLoading) {
    commit(types.LOADING, isLoading)
  },
  // login
  actionLogin ({ commit }, user) {
    // 目前沒找到比較好的範例 API，因此使用延遲 1.5s 模擬 ajax 以及簡單驗證。
    console.log('1. actionLogin')
    commit(types.USER, user) // success 儲存 token
    // commit(types.LOADING, true) // 打開遮罩
    // // 使用 Promise 包裝 API
    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     commit(types.USER, user) // success 儲存 token
    //     commit(types.LOADING, false) // 關閉遮罩
    //     resolve() // resolve 結果會在 then 裡面收到
    //   }, 1500)
    // })
  },
  resetLogin ({ commit }) {
    //console.log('1. reset Login')
    commit(types.CLEARUSER)
  },
  setLanguage ({ commit }, lang) {
    commit(types.LANGUAGE, lang)
  },
  actionIncrease ({ commit }) {
    commit(types.INCREASE)
  },
  actionDecrease ({ commit }) {
    commit(types.DECREASE)
  },
  actionResetCount ({ commit }) {
    commit(types.RESETCOUNT)
  },
  actionAppId ({ commit }, id) {
    commit(types.APPID, id)
  },
  actionPageId ({ commit }, id) {
    commit(types.PAGEID, id)
  }
}

export const mutations = {
  [types.LOADING] (state, isLoading) {
    state.loading = isLoading
  },
  [types.USER] (state, user) {
    //console.log('set USER')
    state.user = user
  },
  [types.CLEARUSER] (state) {
    //console.log('CLEAR USER')
    state.user = {
      iD: '',
      name: '匿名者',
      type: '',
      status: '4',
      loginTime: new Date(),
      isInit: false
    }
  },
  [types.LANGUAGE] (state, setlang) {
    state.lang = setlang
    // 設定 Vue config 將會改變使用的語系
    //i18n.locale = state.lang
    // app.$i18n.locale = setlang
    localStorage.setItem('lang', setlang)

  },
  [types.INCREASE] (state, user) {
    state.loadCount++
  },
  [types.DECREASE] (state, user) {
    state.loadCount--
  },
  [types.RESETCOUNT] (state, user) {
    state.loadCount=0
  },
  [types.APPID] (state, id) {
    state.appId = id
  },
  [types.PAGEID] (state, id) {
    state.pageId = id
  }
}



// WEBPACK FOOTER //
// ./src/store/root.js